import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';
import { Menu, MenuElement, MenuPanel, MenuProps } from '@spazious/dollhouse-uikit';

import { MenuDialogButtons } from '../MenuDialogButtons/index.js';
import { MenuNavButtons } from '../MenuNavButtons/index.js';

export type SideMenuElement = MenuElement;

export interface SideMenuProps extends MenuProps {}

export const SideMenu = styled(
  forwardRef<SideMenuElement, SideMenuProps>((props, ref) => {
    return (
      <Menu ref={ref} column {...props}>
        <MenuPanel>
          <MenuNavButtons />
        </MenuPanel>
        <MenuPanel>
          <MenuDialogButtons />
        </MenuPanel>
      </Menu>
    );
  })
).withConfig({
  displayName: 'SideMenu',
})<SideMenuProps>`
  transition: background-color 0.3s ease-in-out;
  background-color: var(--spz-sys-color-surface-container);
  // background: linear-gradient(
  //   0deg,
  //   var(--spz-sys-color-surface-container-low) 0%,
  //   var(--spz-sys-color-surface-container) 50%,
  //   var(--spz-sys-color-surface-container-high) 100%
  // );
`;
